import { entity } from "@mhmo91/ican";
import { firestore } from "@mhmo91/ican/firestore/binding";
import { z } from "zod";
import { type Actor, Id } from "../workspace.entity.ts";

// Global uniqueness and public routing share this minimal index. Provider
// handles, DNS proof and private actor identity stay on the organization record.
export const DomainClaimSchema = z
	.object({
		orgId: Id,
		registrationId: Id,
		active: z.boolean(),
	})
	.strict();
export type DomainClaim = z.infer<typeof DomainClaimSchema>;
export const DomainClaim = entity<Actor>()({
	schema: DomainClaimSchema,
	actions: ["read"] as const,
})
	.pipe(({ can }) => [can("read").when((data) => data.active.eq(true))])
	.adaptor(
		firestore({ hierarchicalGrants: true, path: "domainClaims/{hostname}" }),
	);
